import { spacing } from '../spacing'
import { type ComponentCreation } from './types'

export const muiSvgIcon = {
  MuiSvgIcon: {
    styleOverrides: {
      fontSizeSmall: {
        fontSize: spacing(2.5),
      },
      fontSizeMedium: {
        fontSize: spacing(3),
      },
      fontSizeLarge: {
        fontSize: spacing(3.5),
      },
    },
  },
} satisfies ComponentCreation
